import { render } from "./NavTitle.vue?vue&type=template&id=1f2e9a4a&scoped=true"
import script from "./NavTitle.vue?vue&type=script&lang=ts"
export * from "./NavTitle.vue?vue&type=script&lang=ts"

import "./NavTitle.vue?vue&type=style&index=0&id=1f2e9a4a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f2e9a4a"

export default script